import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rowCheckbox", "selectAll", "bulkBar", "selectedCount"]

  connect() {
    this.updateSelection()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.rowCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })

    this.updateSelection()
  }

  toggleRow() {
    this.updateSelection()
  }

  updateSelection() {
    const selectedCount = this.rowCheckboxTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = selectedCount
    }

    if (this.hasBulkBarTarget) {
      this.bulkBarTarget.classList.toggle("hidden", selectedCount === 0)
    }

    if (!this.hasSelectAllTarget) return

    const total = this.rowCheckboxTargets.length
    this.selectAllTarget.checked = total > 0 && selectedCount === total
    this.selectAllTarget.indeterminate = selectedCount > 0 && selectedCount < total
  }
}
